/* revermieux — fiche produit : galerie, lots, variantes par article, ajout au panier */

function formatMoney(cents, format) {
  const fmt = (value, thousands, decimal, precision) => {
    const fixed = (value / 100).toFixed(precision);
    const parts = fixed.split('.');
    const whole = parts[0].replace(/\d(?=(\d{3})+(?!\d))/g, (d) => d + thousands);
    return precision > 0 ? whole + decimal + parts[1] : whole;
  };
  return format.replace(/{{\s*(\w+)\s*}}/g, (_, key) => {
    switch (key) {
      case 'amount_no_decimals':
        return fmt(cents, ',', '.', 0);
      case 'amount_with_comma_separator':
        return fmt(cents, '.', ',', 2);
      case 'amount_no_decimals_with_comma_separator':
        return fmt(cents, '.', ',', 0);
      case 'amount_with_space_separator':
        return fmt(cents, ' ', ',', 2);
      case 'amount_no_decimals_with_space_separator':
        return fmt(cents, ' ', ',', 0);
      case 'amount_with_period_and_space_separator':
        return fmt(cents, ' ', '.', 2);
      case 'amount_with_apostrophe_separator':
        return fmt(cents, "'", '.', 2);
      default:
        return fmt(cents, ',', '.', 2);
    }
  });
}

function initGallery(root) {
  const track = root.querySelector('[data-rmp-track]');
  if (!track) return { goToMedia() {}, setColor() {}, imageFor: () => '' };

  // Même ordre pour les photos et leurs vignettes : l'index sert de lien entre les deux.
  const allSlides = Array.from(track.children);
  const allThumbs = Array.from(root.querySelectorAll('[data-rmp-go]'));
  const strip = root.querySelector('[data-rmp-thumbs]');
  const prev = root.querySelector('[data-rmp-prev]');
  const next = root.querySelector('[data-rmp-next]');
  const count = root.querySelector('[data-rmp-count]');
  const total = root.querySelector('[data-rmp-total]');
  let slides = allSlides.filter((slide) => !slide.hidden);
  let thumbs = allThumbs.filter((thumb) => !thumb.hidden);
  let current = 0;
  let color = null;

  const smooth = () => (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');

  const setCurrent = (index) => {
    current = index;
    thumbs.forEach((thumb, i) => {
      if (i === index) {
        thumb.setAttribute('aria-current', 'true');
        if (strip && strip.scrollWidth > strip.clientWidth) {
          strip.scrollTo({ left: thumb.offsetLeft - strip.clientWidth / 2 + thumb.clientWidth / 2, behavior: smooth() });
        }
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === slides.length - 1;
    if (count) count.textContent = String(index + 1);
  };

  const goTo = (index, instant) => {
    const target = Math.max(0, Math.min(slides.length - 1, index));
    track.scrollTo({ left: target * track.clientWidth, behavior: instant ? 'auto' : smooth() });
    setCurrent(target);
  };

  let frame = 0;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      if (!track.clientWidth) return;
      const index = Math.round(track.scrollLeft / track.clientWidth);
      if (index !== current && index < slides.length) setCurrent(index);
    });
  });

  allThumbs.forEach((thumb) => thumb.addEventListener('click', () => goTo(thumbs.indexOf(thumb))));
  if (prev) prev.addEventListener('click', () => goTo(current - 1));
  if (next) next.addEventListener('click', () => goTo(current + 1));

  const applyColor = (wanted) => {
    const specific = [];
    const shared = [];
    allSlides.forEach((slide, i) => {
      const slideColor = slide.dataset.color || '';
      if (!slideColor) shared.push(i);
      else if (slideColor === wanted) specific.push(i);
    });
    // Photos de la couleur d'abord, puis les photos communes. Une couleur sans photo ne montre
    // que les photos communes ; s'il n'y en a aucune, on garde tout plutôt qu'un carrousel vide.
    let order = specific.concat(shared);
    if (!specific.length && !shared.length) order = allSlides.map((_, i) => i);

    const keep = new Set(order);
    allSlides.forEach((slide, i) => {
      slide.hidden = !keep.has(i);
    });
    allThumbs.forEach((thumb, i) => {
      thumb.hidden = !keep.has(i);
    });
    order.forEach((i) => {
      track.appendChild(allSlides[i]);
      if (strip && allThumbs[i]) strip.appendChild(allThumbs[i]);
    });
    slides = order.map((i) => allSlides[i]);
    thumbs = order.map((i) => allThumbs[i]).filter(Boolean);

    const many = slides.length > 1;
    if (strip) strip.hidden = !many;
    if (prev) prev.hidden = !many;
    if (next) next.hidden = !many;
    if (total) total.textContent = String(slides.length);
    track.scrollTo({ left: 0, behavior: 'auto' });
    setCurrent(0);
  };

  return {
    setColor(wanted) {
      if (wanted === color) return;
      color = wanted;
      applyColor(wanted);
    },
    goToMedia(mediaId) {
      if (!mediaId) return;
      const index = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index >= 0 && index !== current) goTo(index);
    },
    /** Petite image d'une couleur, prise dans les vignettes du carrousel. */
    imageFor(wanted) {
      const index = allSlides.findIndex((slide) => slide.dataset.color && slide.dataset.color === wanted);
      const image = index >= 0 && allThumbs[index] ? allThumbs[index].querySelector('img') : null;
      return image ? image.getAttribute('src') || '' : '';
    },
  };
}

function initProduct(root) {
  if (root.dataset.rmpReady) return;
  root.dataset.rmpReady = '1';

  const dataNode = root.querySelector('[data-rmp-data]');
  if (!dataNode) return;
  const data = JSON.parse(dataNode.textContent);
  const money = (cents) => formatMoney(cents, data.money);
  const gallery = initGallery(root);

  const form = root.querySelector('[data-rmp-form]');
  const offers = Array.from(root.querySelectorAll('[data-rmp-offer]'));
  const cta = root.querySelector('[data-rmp-cta]');
  const ctaLabel = root.querySelector('[data-rmp-cta-label]');
  const ctaPrice = root.querySelector('[data-rmp-cta-price]');
  const errorNode = root.querySelector('[data-rmp-err]');
  const idInput = root.querySelector('[data-rmp-id]');
  const qtyInput = root.querySelector('[data-rmp-qty]');
  const unitPrice = root.querySelector('[data-rmp-unit-price]');
  const unitStrike = root.querySelector('[data-rmp-unit-strike]');
  const sticky = root.querySelector('[data-rmp-sticky]');
  const stickyLabel = root.querySelector('[data-rmp-sticky-label]');
  const stickyPrice = root.querySelector('[data-rmp-sticky-price]');
  const stickyBtn = root.querySelector('[data-rmp-sticky-btn]');
  if (!form || !offers.length || !cta) return;

  const topInputs = Array.from(root.querySelectorAll('[data-rmp-top-opt]'));
  const hasPickers = Boolean(root.querySelector('[data-rmp-opt]')) || topInputs.length > 0;
  const colorIndex = typeof data.colorIndex === 'number' ? data.colorIndex : -1;
  const maxQty = Math.max(...offers.map((offer) => Number(offer.dataset.q)));
  const firstVariant = data.variants.find((v) => String(v.id) === idInput.value) || data.variants[0];

  /** Options choisies pour chaque article du lot (index = position dans le lot). */
  const units = Array.from({ length: maxQty }, () => firstVariant.o.slice());

  const findVariant = (options) => data.variants.find((v) => v.o.every((value, i) => value === options[i]));
  const selectedOffer = () => offers.find((offer) => offer.classList.contains('is-on')) || offers[0];

  /** Cadeaux du lot (ex. taies), répartis entre les articles et de la même couleur quand elle existe. */
  const giftLines = (qty, total) => {
    const lines = new Map();
    const gift = data.gift;
    if (!gift || !gift.variants || !gift.variants.length || !qty || !total) return lines;
    for (let g = 0; g < total; g += 1) {
      const unit = Math.min(qty - 1, Math.floor((g * qty) / total));
      const options = hasPickers ? units[unit] : firstVariant.o;
      const own = colorIndex > -1 ? options[colorIndex] : null;
      const color = own && data.giftMap && data.giftMap[own] ? data.giftMap[own] : own;
      const match =
        (color && gift.variants.find((v) => v.a && v.o.includes(color))) || gift.variants.find((v) => v.a);
      if (match) lines.set(match.id, (lines.get(match.id) || 0) + 1);
    }
    return lines;
  };

  const priceFor = (offer) => {
    const qty = Number(offer.dataset.q);
    const pct = Number(offer.dataset.pct) || 0;
    const promo = Math.min(qty, Number(offer.dataset.promo) || 0);
    let base = 0;
    let final = 0;
    let compare = 0;
    let available = true;
    const lines = new Map();
    const picked = [];
    for (let i = 0; i < qty; i += 1) {
      const variant = hasPickers ? findVariant(units[i]) : firstVariant;
      if (!variant || !variant.a) {
        available = false;
        continue;
      }
      picked.push(variant);
      base += variant.p;
      compare += Math.max(variant.c, variant.p);
      lines.set(variant.id, (lines.get(variant.id) || 0) + 1);
    }
    // Shopify calcule la remise article par article et l'arrondit au centime inférieur.
    // Les articles « promo » (ex. le 2e à -50 %) sont les moins chers du lot, comme dans « Achetez X, obtenez Y ».
    picked
      .slice()
      .sort((a, b) => a.p - b.p)
      .forEach((variant, i) => {
        const rate = i < promo ? data.promoPct || 0 : pct;
        final += variant.p - Math.floor((variant.p * rate) / 100);
      });
    let strike = 0;
    if (compare > final && compare > base) strike = compare;
    else if (pct > 0 || promo > 0) strike = base;
    return { qty, base, final, strike, available, lines };
  };

  /** Article en plus du lot (ex. oreiller) : prix avec remise, arrondi comme Shopify. */
  const addonsFor = (offer) =>
    Array.from(offer.querySelectorAll('[data-rmp-addon]'))
      .map((node) => addonFor(node))
      .filter(Boolean);

  const addonFor = (node) => {
    const addon = data.addons && data.addons[node.dataset.rmpAddon];
    if (!addon) return null;
    const qty = Number(node.dataset.n) || 0;
    const selects = Array.from(node.querySelectorAll('[data-rmp-addon-opt]'));
    // Une variante par article (choix de couleur), sinon la variante par défaut pour tous.
    const picked = Array.from({ length: qty }, (_, i) => {
      const select = selects[i] || selects[0];
      const id = select ? Number(select.value) : addon.id;
      return addon.variants.find((v) => v.id === id) || addon.variants.find((v) => v.id === addon.id) || addon.variants[0];
    });
    const lines = new Map();
    let final = 0;
    let strike = 0;
    picked.forEach((v) => {
      final += v.p - Math.floor((v.p * (addon.pct || 0)) / 100);
      strike += v.p;
      lines.set(v.id, (lines.get(v.id) || 0) + 1);
    });
    return {
      node,
      qty,
      on: node.querySelector('[data-rmp-addon-on]').checked,
      final,
      strike,
      lines,
      first: picked[0],
    };
  };

  const syncPickers = () => {
    root.querySelectorAll('[data-rmp-unit]').forEach((row) => {
      const index = Number(row.dataset.rmpUnit);
      const options = units[index];
      row.querySelectorAll('[data-rmp-opt]').forEach((select) => {
        const optionIndex = Number(select.dataset.rmpOpt);
        if (select.value !== options[optionIndex]) select.value = options[optionIndex];
        const dot = select.parentElement.querySelector('[data-rmp-dot]');
        if (dot) {
          const color = select.selectedOptions[0] && select.selectedOptions[0].dataset.color;
          dot.style.background = color || '';
        }
      });
      const variant = findVariant(options);
      const imageBox = row.querySelector('[data-rmp-unit-img]');
      if (imageBox) {
        const image = imageBox.querySelector('img');
        const source = (variant && variant.i) || (colorIndex > -1 ? gallery.imageFor(options[colorIndex]) : '');
        if (source) {
          if (image.getAttribute('src') !== source) image.setAttribute('src', source);
          imageBox.hidden = false;
        } else {
          imageBox.hidden = true;
        }
      }
    });
  };

  /** Pastilles et boutons du haut : ils reflètent toujours le premier article du lot. */
  const syncTop = () => {
    topInputs.forEach((input) => {
      const optionIndex = Number(input.dataset.rmpTopOpt);
      input.checked = units[0][optionIndex] === input.value;
      const candidate = units[0].slice();
      candidate[optionIndex] = input.value;
      const variant = findVariant(candidate);
      input.parentElement.classList.toggle('is-out', !variant || !variant.a);
    });
    root.querySelectorAll('[data-rmp-top-val]').forEach((node) => {
      node.textContent = units[0][Number(node.dataset.rmpTopVal)];
    });
  };

  /** Le carrousel suit le premier article : photos de sa couleur, puis image de sa variante. */
  const showFirstUnit = () => {
    if (colorIndex > -1) gallery.setColor(units[0][colorIndex]);
    const variant = findVariant(units[0]);
    if (variant) gallery.goToMedia(variant.m);
  };

  const render = () => {
    syncPickers();
    syncTop();

    offers.forEach((offer) => {
      const price = priceFor(offer);
      const finalNode = offer.querySelector('[data-rmp-final]');
      const strikeNode = offer.querySelector('[data-rmp-strike]');
      const savedNode = offer.querySelector('[data-rmp-saved]');
      const savedValue = offer.querySelector('[data-rmp-saved-v]');
      const outNode = offer.querySelector('[data-rmp-out]');
      if (price.available) {
        finalNode.textContent = money(price.final);
        strikeNode.textContent = money(price.strike);
        strikeNode.hidden = !(price.strike > price.final);
        if (savedNode) {
          savedValue.textContent = money(price.strike - price.final);
          savedNode.hidden = !(price.strike > price.final);
        }
      }
      if (outNode) outNode.hidden = price.available;
      addonsFor(offer).forEach((addon) => {
        addon.node.querySelector('[data-rmp-addon-final]').textContent = money(addon.final);
        const addonStrike = addon.node.querySelector('[data-rmp-addon-strike]');
        addonStrike.textContent = money(addon.strike);
        addonStrike.hidden = !(addon.strike > addon.final);
        addon.node.classList.toggle('is-off', !addon.on);
        addon.node.querySelectorAll('[data-rmp-addon-opt]').forEach((select) => {
          const dot = select.parentElement.querySelector('[data-rmp-dot]');
          const option = select.selectedOptions[0];
          if (dot) dot.style.background = (option && option.dataset.color) || '';
        });
        const thumb = addon.node.querySelector('[data-rmp-addon-img]');
        if (thumb && addon.first && addon.first.i) {
          if (!thumb.dataset.fallback) thumb.dataset.fallback = thumb.getAttribute('src');
          thumb.removeAttribute('srcset');
          thumb.setAttribute('src', addon.first.i);
        } else if (thumb && thumb.dataset.fallback) {
          thumb.setAttribute('src', thumb.dataset.fallback);
        }
      });
    });

    const offer = selectedOffer();
    const price = priceFor(offer);
    const chosen = addonsFor(offer).filter((addon) => addon.on && addon.qty);
    const total = price.final + chosen.reduce((sum, addon) => sum + addon.final, 0);
    const firstUnit = hasPickers ? findVariant(units[0]) : firstVariant;

    if (firstUnit) {
      unitPrice.textContent = money(firstUnit.p);
      unitStrike.textContent = money(firstUnit.c);
      unitStrike.hidden = !(firstUnit.c > firstUnit.p);
      idInput.value = String(firstUnit.id);
    }
    qtyInput.value = String(price.qty);

    cta.disabled = !price.available;
    ctaLabel.textContent = price.available ? ctaLabel.dataset.default : data.soldOut;
    ctaPrice.textContent = price.available ? money(total) : '';
    ctaPrice.hidden = !price.available;

    if (sticky) {
      stickyLabel.textContent = [offer.dataset.label].concat(chosen.map((addon) => addon.node.dataset.label)).join(' + ');
      stickyPrice.textContent = price.available ? money(total) : data.soldOut;
      stickyBtn.disabled = !price.available;
    }
  };

  offers.forEach((offer) => {
    const radio = offer.querySelector('input[type="radio"]');
    radio.addEventListener('change', () => {
      offers.forEach((other) => other.classList.toggle('is-on', other === offer));
      hideError();
      render();
    });
  });

  // Cocher l'article en plus d'un autre lot sélectionne aussi ce lot.
  root.querySelectorAll('[data-rmp-addon-on]').forEach((box) => {
    box.addEventListener('change', () => {
      const offer = box.closest('[data-rmp-offer]');
      const radio = offer.querySelector('input[type="radio"]');
      if (box.checked && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change'));
        return;
      }
      render();
    });
  });

  // Choisir une couleur d'oreiller coche la ligne et sélectionne son lot.
  root.querySelectorAll('[data-rmp-addon-opt]').forEach((select) => {
    select.addEventListener('change', () => {
      const offer = select.closest('[data-rmp-offer]');
      const box = select.closest('[data-rmp-addon]').querySelector('[data-rmp-addon-on]');
      const radio = offer.querySelector('input[type="radio"]');
      if (box) box.checked = true;
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change'));
        return;
      }
      render();
    });
  });

  root.querySelectorAll('[data-rmp-opt]').forEach((select) => {
    select.addEventListener('change', () => {
      const row = select.closest('[data-rmp-unit]');
      const index = Number(row.dataset.rmpUnit);
      units[index][Number(select.dataset.rmpOpt)] = select.value;
      hideError();
      render();
      if (index === 0) showFirstUnit();
    });
  });

  // Un choix en haut s'applique à tous les articles du lot ; chacun reste modifiable ensuite.
  topInputs.forEach((input) => {
    input.addEventListener('change', () => {
      const optionIndex = Number(input.dataset.rmpTopOpt);
      units.forEach((options) => {
        options[optionIndex] = input.value;
      });
      hideError();
      render();
      showFirstUnit();
    });
  });

  function hideError() {
    if (errorNode) errorNode.hidden = true;
  }

  function showError(message) {
    if (!errorNode) return;
    errorNode.textContent = message;
    errorNode.hidden = false;
  }

  let busy = false;

  async function addToCart() {
    if (busy) return;
    const offer = selectedOffer();
    const price = priceFor(offer);
    if (!price.available) return;

    busy = true;
    hideError();
    cta.classList.add('is-busy');
    if (stickyBtn) stickyBtn.disabled = true;

    const addonItems = [];
    addonsFor(offer).forEach((addon) => {
      if (addon.on && addon.qty) addon.lines.forEach((quantity, id) => addonItems.push({ id, quantity }));
    });
    const items = Array.from(price.lines, ([id, quantity]) => ({ id, quantity }))
      .concat(addonItems)
      .concat(Array.from(giftLines(price.qty, Number(offer.dataset.gifts) || 0), ([id, quantity]) => ({ id, quantity })));
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((node) => node.dataset.sectionId)
      .filter(Boolean);

    let events = null;
    try {
      events = await import('@shopify/events');
    } catch (error) {
      events = null;
    }

    let deferred = null;
    if (events && events.CartLinesUpdateEvent) {
      deferred = events.CartLinesUpdateEvent.createPromise();
      // Sans écouteur, un rejet ne doit pas remonter comme erreur non gérée.
      deferred.promise.catch(() => {});
      root.dispatchEvent(
        new events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: items.map((item) => ({ merchandiseId: String(item.id), quantity: item.quantity })),
          promise: deferred.promise,
        })
      );
    }

    const fetchCart = () =>
      fetch(`${data.cart}.json`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());

    try {
      const response = await fetch(data.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items, sections: sectionIds.join(',') }),
      });
      const result = await response.json();
      const failed = Boolean(result.status);

      if (failed) showError(result.description || result.message || "L'ajout au panier a échoué. Réessayez.");

      if (deferred) {
        const cart = await fetchCart();
        deferred.resolve({
          cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            source: 'rm-product',
            sourceId: root.dataset.sectionId,
            itemCount: items.reduce((sum, item) => sum + item.quantity, 0),
            productId: String(data.productId),
            sections: failed ? undefined : result.sections,
            didError: failed,
          },
        });
      } else if (!failed) {
        window.location.assign(data.cart);
        return;
      }

      if (!failed) {
        ctaLabel.textContent = data.added;
        ctaPrice.hidden = true;
        window.setTimeout(render, 2200);
        if (data.openCart) {
          const cartDrawer = document.querySelector('cart-drawer-component');
          const host = cartDrawer && cartDrawer.closest('theme-drawer');
          if (host && typeof host.open === 'function' && !host.isOpen) host.open();
        }
      }
    } catch (error) {
      if (deferred) deferred.reject(error);
      showError("L'ajout au panier a échoué. Vérifiez votre connexion et réessayez.");
    } finally {
      busy = false;
      cta.classList.remove('is-busy');
      if (stickyBtn) stickyBtn.disabled = false;
    }
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    addToCart();
  });

  if (sticky && stickyBtn) {
    stickyBtn.addEventListener('click', addToCart);
    // Visible dès que le bouton principal est passé au-dessus de l'écran (y compris après un saut d'ancre).
    let ticking = false;
    const update = () => {
      ticking = false;
      const passed = cta.getBoundingClientRect().bottom < 0;
      if (passed === sticky.classList.contains('is-in')) return;
      sticky.classList.toggle('is-in', passed);
      sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
      stickyBtn.tabIndex = passed ? 0 : -1;
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  const dialog = root.querySelector('[data-rmp-guide]');
  const opener = root.querySelector('[data-rmp-guide-open]');
  if (dialog && opener && typeof dialog.showModal === 'function') {
    opener.addEventListener('click', () => dialog.showModal());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-rmp-guide-close]')) dialog.close();
    });
  } else if (opener) {
    opener.hidden = true;
  }

  render();
  showFirstUnit();
}

function initAll(scope) {
  (scope || document).querySelectorAll('[data-rmp]').forEach(initProduct);
}

initAll();
document.addEventListener('shopify:section:load', (event) => initAll(event.target));
